import { LitElement } from "lit";
import { addGlobalStylesToShadowRoot } from "../util/globalStyleSheetsUtil.js";

export abstract class LitElementBase extends LitElement {
  connectedCallback() {
    super.connectedCallback();
    addGlobalStylesToShadowRoot(this.shadowRoot!);
  }
}
